import { motion, useScroll, useTransform } from "framer-motion";
import { Box, Container, Typography } from "@mui/material";

import img from "../../../Images/413349251-Home-Page-YALE-Lock-v1a-pg.jpg";
import img2 from "../../../Images/245_24_Apple_Music_for_Control4_www_update_1.png";
import img3 from "../../../Images/OS_3_WWW_Home_Partner_Logos_V2b.jpg";
import { useRef } from "react";

function ImageSides() {
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start end", "end start"],
  });

  const translate = useTransform(
    scrollYProgress,
    [0, 0.3, 0.6, 1],
    [70, 0, -70, -170]
  );

  const translate2 = useTransform(
    scrollYProgress,
    [0, 0.3, 0.6, 1],
    [-70, 0, 70, 170]
  );

  return (
    <div ref={containerRef} className="md:mb-24">
      <Container
        maxWidth="xl"
        sx={{
          display: "flex",
          flexDirection: { xs: "column-reverse", md: "row" },
          gap: 5,
        }}
      >
        <Box sx={{ width: "100%" }}>
          <motion.img
            src={img}
            className="h-[80vh] md:h-[70vh] lg:h-[85vh] w-full object-cover mb-7 lg:mb-20"
            style={{ y: window.innerWidth > 768 && translate }}
          />
          <div>
            <Typography
              variant="body1"
              fontSize={15.5}
              letterSpacing={1}
              className="w-full lg:w-2/3"
              mb={5}
            >
              Manage them all with a simple tap, a single voice command, or even
              allow things to happen automatically with no interaction at all.
            </Typography>
            <img src={img3} alt="" className="w-full" />
          </div>
        </Box>
        <Box sx={{ width: "100%" }}>
          <div className="flex flex-col gap-5 mb-7 lg:mb-20">
            <Typography
              variant="subtitle1"
              color="primary.dark"
              sx={{ textTransform: "uppercase", fontWeight: 300, fontSize: 17 }}
            >
              Smart home | Choice
            </Typography>
            <Typography
              variant="h4"
              color="primary.content"
              sx={{ textTransform: "uppercase" }}
              fontSize={{ md: 28, lg: 34 }}
            >
              <span style={{ fontWeight: 300 }}>Playing nicely with</span>
              <br />
              <b>your beloved brands</b>
            </Typography>
            <Typography className="relative">
              Don’t ditch your favorite products; let’s join them all together!
              Your MEETFUTUR Smart Home OS has the ability to operate with
              tens-of-thousands of third-party products.
            </Typography>
          </div>
          <motion.img
            src={img2}
            className="h-[80vh] md:h-[70vh] lg:h-[85vh] w-full object-cover"
            style={{ y: window.innerWidth > 768 && translate2 }}
          />
        </Box>
      </Container>
    </div>
  );
}

export default ImageSides;
